<template>
  <main class="main-content home">
    <img id="logo" alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to My Vue.js + TypeScript App" />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HelloWorld from '@/components/HelloWorld.vue'

export default defineComponent({
  name: 'HomeView',
  components: {
    HelloWorld
  }
});
</script>

<style>
.home #logo {
  display: block;
  max-width: 9em;
  width: 100%;
  margin: auto;
  image-rendering: pixelated;
  aspect-ratio: 1;
}

@media screen and (min-width: 800px) {
  .home #logo {
    margin: 2em 2em;
    margin-left: 6em;
    float: left;
  }

  br {
    clear: left;
  }
}
</style>
